import { Route } from 'react-router-dom';

// Pages.
import ProjectPlanPage from 'pages/sun_capital/master-plane/Horizontal/109 Building/plan/ProjectPlanPage';
import ProjectGalleryPage from 'pages/sun_capital/master-plane/Horizontal/109 Building/gallery/ProjectGalleryPage';
import PaymentPage from 'pages/sun_capital/master-plane/Horizontal/109 Building/payment/PaymentPage';
const Index = () => {
  
  return (
    <>
      <Route exact path={`/sun_capital/master-plan/horizontal/109-building/plan`}>
        <ProjectPlanPage />
      </Route>
      <Route exact path={`/sun_capital/master-plan/horizontal/109-building/gallery`}>
        <ProjectGalleryPage />
      </Route>
      <Route exact path={`/sun_capital/master-plan/horizontal/109-building/payment`}>
        <PaymentPage />
      </Route>
    </>
  );
};

export default Index;
